import React, { useContext, useEffect } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { TemplatePage } from '../../../components/TemplatePage'
import { globalStyle } from '../../../theme/global'
import { useForm } from '../../../hooks/useForm'
import { PondCage } from '../../../components/PondCage/Index'
import { disabledGray, textColor, toqueColor } from '../../../theme/colors'
import { useKeyboardVisibility } from '../../../hooks/useKeyboardVisibility'
import { StackNavigationProp } from '@react-navigation/stack'
import { useNavigation } from '@react-navigation/native'
import { NecropsyRoutes } from '../../../navigator/types'
import { NecropsyContext } from '../../../context/Necropsy/Provider'
import { getDateTime } from '../../../helpers/getDateTime'
import { Separator } from '../../../components/Separator'
import { Button } from '../../../components/Button'
import { FormHeader } from '../components/FormHeader'
import { stringToHex } from '../helpers'
import { useTranslation } from 'react-i18next'

interface NavigationParams extends StackNavigationProp<NecropsyRoutes, 'Necropsy'> {}

export const Necropsy = () => {
  const { setCageSelection, form, setInitialForm } = useContext(NecropsyContext)
  const { t } = useTranslation()

  const navigation = useNavigation<NavigationParams>()
  const { values, onChangeValues } = useForm({
    levelThreeId: 0,
    cageName: '',
  })
  const { isKeyboardVisible } = useKeyboardVisibility()

  const isDisabledButton = (): boolean => values.levelThreeId === 0

  const handleContinue = () => {
    setCageSelection({
      cageId: values.levelThreeId,
      cageName: values.cageName,
      formId: stringToHex(Number(new Date().getTime().toString() + values.levelThreeId.toString())),
    })

    navigation.navigate('ExternalPhoto')
  }

  useEffect(() => {
    const { date, time } = getDateTime()
    setInitialForm({
      date,
      time,
    })
  }, [])

  return (
    <TemplatePage
      styleContent={{ padding: 0, marginBottom: 0 }}
      header
      title={t('Nueva ficha Necropsia')}
    >
      <View style={[globalStyle.viewContainer, { padding: 20 }]}>
        <FormHeader title='Datos' hasTime />

        <Text style={[styles.text]}>{t('JAULA')}</Text>
        <Separator customStyle={styles.separator} />

        <PondCage
          parentId={form.centerId!}
          onChange={(value) => onChangeValues({ value, name: 'levelThreeId' })}
          getName={(itemName) => onChangeValues({ value: itemName, name: 'cageName' })}
        />
      </View>
      {!isKeyboardVisible && (
        <View
          style={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            paddingHorizontal: 24,
          }}
        >
          <Button
            label={t('Comenzar Ficha')}
            onPress={handleContinue}
            disabled={isDisabledButton()}
            customStyle={[
              { width: '100%', marginBottom: 10 },
              isDisabledButton() && { backgroundColor: disabledGray },
            ]}
          />
        </View>
      )}
    </TemplatePage>
  )
}

const styles = StyleSheet.create({
  separator: {
    borderBottomWidth: 3,
    width: 31,
    borderBottomColor: toqueColor,
    marginBottom: 24,
    marginTop: 10,
  },
  text: {
    color: textColor,
    fontSize: 16,
    fontWeight: '500',
    marginTop: 24,
  },
})
